/*
 * @Author: cjw 
 * @Date: 2021-03-23 16:47:22 
 * @Last Modified by: cjw
 * @Last Modified time: 2021-09-08 09:53:01
 */

/*
 * 提供当前活动行功能
 *
 * 提供以下接口
 * 1. current     获取、设置当前活动行对象
*/

// 是否为数组的下标（索引）
// function isArrayIndex(obj) {
//     return /^\d+$/.test(obj)
// }

function createReactiveDataTable(target, meta) {

    // 如果对象已有代理，则返回代理
    let observed = meta.toProxy.get(target)
    if (observed !== void 0) {
        return observed
    }

    if (meta.toRaw.get(target)) {
        return target
    }

    const createSetter = function(meta) {
        return function set(target, property, value, receiver) {

            // 新增行时不知为什么，无法让界面刷新为当前行，暂时注释掉，手动设置当前行
            // if (isArrayIndex(property)) {
            //     if ((target.length - 1) < property) {
            //         // 数组的新增实质是最后一个下标+1进行赋值，所以判断不存在该下标时为新增
            //         const result = Reflect.set(target, property, value, receiver)
            //         if (result) {
            //             meta.position = parseInt(property)
            //             meta.current = Reflect.get(target, property, receiver)// target[meta.position]
            //         }
            //         return result
            //     }
            // }
    
            switch (property) {
                case 'length':
                    if (target.length > value) {
                        const result = Reflect.set(target, property, value, receiver)
                        if (result) {
                            // 数据长度减少时，意味着删除了记录，需要重新调整当前行
                            if (meta.position >= target.length) {
                                meta.position = target.length - 1
                                meta.current = target[meta.position]
                            } else {
                                meta.current = target[meta.position]
                            }
                        }
                        return result
                    }
                    break;
                default:
                    break;
            }
    
            // 设置属性值
            return Reflect.set(target, property, value, receiver)
        }
    }

    const handlers = {
        set: createSetter(meta)
    }

    // 创建 Proxy 代理
    observed = new Proxy(target, handlers)
    meta.toProxy.set(target, observed)
    meta.toRaw.set(observed, target)
    return observed
}

// 创建响应式对象
function createReactiveDataSource(target, meta) {

    const createGetter = function(meta) {
        return function get(target, property, receiver) {
            switch (property) {
                case 'clear':
                    // 调用 proxy-changes 的 clear 时，需要同时将 current、position 清除
                    meta.current = null
                    meta.position = -1
                    return Reflect.get(target, property, receiver)
                case 'current':
                    // 获取当前行对象
                    return meta.current ?? {}
                case 'datas': {
                    // 进行代理是为了解决删除行时改变当前活动行
                    const datas = Reflect.get(target, property, receiver)
                    return createReactiveDataTable(datas, meta)
                }
                default:
                    break;
            }
            
            return Reflect.get(target, property, receiver)
        }
    }

    const createSetter = function(meta) {
        return function set(target, property, value, receiver) {
            switch (property) {
                case 'current':
                    // 提供设置当前行
                    if (meta.current !== value) {
                        if (value) {
                            const index = target.datas.findIndex(el => el === value)
                            if (index !== -1) {
                                meta.current = value
                                meta.position = index
                                return true
                            } else {
                                throw `无法设置当前行，当前数据源不存在指定的行`
                            }
                        } else {
                            meta.current = null
                            meta.position = -1
                            return true
                        }
                    } else {
                        return true
                    }
                default:
                    break;
            }

            // 设置属性值
            return Reflect.set(target, property, value, receiver)
        }
    }

    const handlers = {
        get: createGetter(meta),
        set: createSetter(meta),
    }

    // 创建 Proxy 代理
    return new Proxy(target, handlers)
}

export function ProxyPosition(target, options) {
    const meta = {
        options: options,
        // 已代理的 DataRow 集合（key:原始对象，value:代理对象），用于解决重复代理
        toProxy: new WeakMap(),
        // 已代理的 DataRow 集合（key:代理对象，value:原始对象），与 toProxy 相反
        toRaw: new WeakMap(),
        // 当前行
        current: null,
        // 当前行索引
        position: -1
    }

    const observed = createReactiveDataSource(target, meta)
    if (target.datas.length) {
        // 有记录时设置首行为当前行
        meta.current = observed.datas[0]
        meta.position = 0
    }

    return observed
}